import { Link, useLocation } from "react-router-dom";
import { useAuth } from "../../../../contexts/AuthContext";

const ErrorAPIMypage = () => {
  // ログアウトする
  const { mypageLogout } = useAuth();

  // URLパラメータ
  let isForbidden = false;
  const search = useLocation().search;
  const query = new URLSearchParams(search);
  if (query.get("forbidden") == "1") {
    isForbidden = true;
  }

  return (
    <div className="container">
      <div className="p-top-menu">
        <div className="l-page-con">
          <div className="col-lg-10 offset-lg-1">
            <h1 className="p-heading01">システムエラーが発生しました。</h1>
            <label className="mb-5">
              サーバが混み合っているか、プログラム誤作動によるエラーが発生しました。
              <br />
              ご迷惑おかけいたしまして、大変申し訳ございません。
              <br />
              しばらく経ってから再度ご利用くださいますようお願い申し上げます。
            </label>
            <div className="p-course-page__btn">
              {isForbidden ? (
                <a
                  href="#"
                  className="p-course-page__btn-link mt-5"
                  onClick={mypageLogout}
                >
                  ログアウト
                </a>
              ) : (
                <Link className="p-course-page__btn-link mt-5" to="/mypage/top">
                  マイページトップへ戻る
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ErrorAPIMypage;
